import BaseModel from '../core/BaseModel'
import UserModel from '@/models/UserModel'
export default class DashboardModel extends BaseModel {
    constructor() {
        super({
                name: "dashboard",
                tableName: 'payment_history',
                label: "Dashboard",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                transaction: {
                    name: "transaction",
                    label: "Transaction ID",
                    type: "Computed",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.transaction ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Code ID',
                    filter: {type: 'input', match: 'contains'},
                    width : 8,
                },
                rental_order_id: {
                    name: 'rental_order_id',
                    type: "Computed",
                    label: 'Order ID',
                    computed: (data) => {
                        data.transaction ='' ;
                    },
                    filter: {type: 'input', match: 'contains'},
                    width : 8,
                },
                description: {
                    name: 'description',
                    type: "String",
                    label: 'Description',
                    filter: {type: 'input', match: 'contains'},
                    width : 8,

                },
             
                payment_method: {
                    name: "payment_method",
                    label: "Payment method",
                    // type: "Selection",
                    // custom: 'SelectionText',
                    options: [
                        {value: 'Other', label: 'Other'},
                        {value: 'Square', label: 'Online'},
                        {value: '-', label: '-'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "left",
                    width : 8,

                },
                status: {
                    name: "status",
                    label: "Status",
                    class: "left",
                    width : 15,
                    options: [
                        {value: 'Paid', label: 'Paid'},
                        {value: 'Waiting', label: 'Waiting'},
                        {value: 'Fail', label: 'Fail'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                },
           
                type: {
                    name: "type",
                    label: "Type",
                    class:"left",
                    width : 8,
                    options: [
                        {value: 'Incoming', label: 'Incoming'},
                        {value: 'Outcoming', label: 'Outcoming'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                },
                amount: {
                    name: "type",
                    label: "Request amount",
                    type: "Number",
                    class:"left",
                    width : 8,
                },
                total_payment: {
                    name: "total_payment",
                    label: "Paid amount",
                    type: "Number",
                    class:"left",
                    width : 8,
                },
        
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    // filter: {type: 'input', match: 'contains'},
                    models: new UserModel(),
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at: {
                    name: 'updated_at',
                    // type: "Datetime",
                    label: 'Updated date',
                    width : 8,

                },
                detail_get: {
                    refs: 'obj_updated_by { id fullname } obj_rental_order { id code }',
                    display: false
                },
                detail_get1: {
                    refs: 'date_start  total_late  type code amount status payment_method  total late_fee voucher_id voucher_code voucher_discount redeemed total_payment deletion_reason created_at  updated_at  updated_by created_by  active deleted  uid is_fisrt_pay_week  obj_id  description obj_created_by { id fullname }',
                    display: false
                },
            })
    }
}
